import { IconName } from '@ardoq/icons';
import { Bounds } from '@ardoq/graph';
import type { CanvasRenderingContext } from 'tabview/canvasRendering/types';
import type { BlocksViewNode } from '../../types';
import { rectWidth, rectHeight, rectCenter } from '../../misc/geometry';
import { drawSpriteIcon } from './drawSpriteIcon';
import { groupExpanderRect } from './groupExpanderRect';

const drawExpander = (
  node: BlocksViewNode,
  cell: Bounds,
  textColor: string,
  context: CanvasRenderingContext
) => {
  if (!cell) {
    return;
  }
  const { open } = node;
  const bounds = groupExpanderRect(node, cell);
  const expanderSize = Math.min(rectWidth(bounds), rectHeight(bounds));
  if (expanderSize <= 0) {
    return;
  }
  const [x, y] = rectCenter(bounds);
  const iconName = open ? IconName.UNFOLD_LESS : IconName.UNFOLD_MORE;
  drawSpriteIcon(iconName, expanderSize, textColor, x, y, context);
};

export { drawExpander };
